import { addSentryBreadcrumb } from '../../functions/sentry.js';
import { toastError } from '../../functions/toast/toast.js';

let store;
/**
 * Provides shared set-up for the store. Must be called in app prior to using
 * `getStore`.
 */
const augmentStore = (storeInstance) => {
    store = storeInstance;
    store.subscribe((mutation) => {
        addSentryBreadcrumb(mutation.type, 'Vuex Mutation', mutation.payload);
    });
    store.subscribeAction((action) => {
        addSentryBreadcrumb(action.type, 'Vuex Action', action.payload);
    });
};
/**
 * If a store helper is called before the store is initialized, display a
 * generic toast to the user and throw a more specific error for error
 * reporting. Log a stack trace so the developer can find the source of the
 * error.
 */
const storeNotInitialized = (methodName) => {
    // eslint-disable-next-line no-console
    console.trace();
    toastError('Store not initialized');
    return Error(`The store must be passed to augmentStore before "${methodName}" can be used.`);
};
const getStore = () => {
    if (!store)
        throw storeNotInitialized('getStore');
    return store;
};

export { augmentStore, getStore };
